import {createContext, Dispatch} from 'react'
import {AllActions} from './state/actions'
import {DEFAULT_QUARTERMASTER_STATE} from './types/default-quartermaster-state'
import {QuartermasterState} from './types/quartermaster-state'

export const QuartermasterContext = createContext<{
    state: QuartermasterState | undefined
    dispatch: Dispatch<AllActions>
}>({state: DEFAULT_QUARTERMASTER_STATE, dispatch: () => null})
